// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qg-5";
export var filledCircle = "_qg-4";
export var historyEntry = "_qg-3";
export var messageSideLeft = "_qg-1";
export var messageSideRight = "_qg-2";
export var orderTrackingCarouselWrapper = "_qg-6";
export var orderTrackingInfoContainer = "_qg-0";